<template>
  <div class=""></div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
